module.exports = __webpack_public_path__ + "static/media/three-dots.87b52a3d.svg";